var Buf = require('buf');
var Message = require('message');
var UserList = require('userlist');


var Thread = Buf.extend({
    idAttribute: 'id',
    initialize: function (data, options) {
        this.buffer = options.buffer;
        Buf.prototype.initialize.apply(this, arguments);
        this.messages.buffer = this.buffer;
        this.messages.thread = this;
        this.selected = true;
    },
    fetchLoaded: function (messages) {
        var earliest = this.getEarliestEid();
        _.each(messages, function (m) {
            this.addMessage(m, {silent: true, fetched: true});
        }, this);
        var added = [];
        if (earliest) {
            added = this.messages.filterBeforeEid(earliest);
        } else {
            added = this.messages.toArray();
        }
        if (added.length) {
            this.setEarliestEid(added[0].id);
        }
        this.trigger('fetched', added, earliest);
    },
    getFirst: function () {
        return this.id;
    },
    loadBacklog: function () {
        return this.buffer.loadBacklog();
    },
    hasFirstMessage: function () {
        var first = this.messages.first();
        if (first && first.getMsgId() === this.id) {
            return true;
        }
        return false;
    },
    isInThread: function (m) {
        if (m.isSameThread(m, this.id)) {
            return true;
        }
        var msgids = {};
        msgids[m.getReply()] = true;
        msgids[m.getConcatTag()] = true;
        msgids[m.getDelete()] = true;
        msgids[m.getEdit()] = true;
        delete msgids[undefined];
        return !!this.messages.find(function (mm) {
            return mm.getMsgId() in msgids;
        });
    },
    say: function (message, options) {
        this.reply(this.id, message, options);
    },
    addMessage: function (message, options) {
        options = options || {};
        if (this.isInThread(message)) {
            if (!options.fetched) {
                if (!this.getEarliestEid()) {
                    this.setEarliestEid(message.id);
                }
            }
            this.messages.add(new Message(message.toJSON(), {
                buffer: this
            }), {silent: options.silent});
            if (!message.isEmpty()) {
                var member = message.makeUser();
                var existing = this.members.findWhere({nick: member.get('nick')});
                if (existing) {
                    existing.set(member.attributes);
                } else {
                    this.members.add(member);
                }
            }
        }
    },
    delete: function () {
        this.stopListening();
        this.trigger('delete');
    },
    init: function () {
        this.messages.reset(_.invoke(this.buffer.messages.getThread(this.id), 'toJSON'));
        var first = this.getFirstMessage();
        if (first) {
            this.setEarliestEid(first.id);
        }
        var memberUsers = this.messages.foldl(function (acc, message) {
            if (!message.isEmpty()) {
                var messageUser = message.makeUser();
                acc[messageUser.get('nick')] = messageUser;
            }
            return acc;
        }, {});
        this.members = new UserList(Object.values(memberUsers));
        this.listenTo(this.buffer.messages, 'add', this.addMessage);
        this.listenTo(this.buffer, 'fetchLoaded', this.fetchLoaded);
    },
    messageHandlers: {},
    bid: function () {
        return this.buffer.bid();
    },
    equals: function (thread) {
        return this.bid() == thread.bid() && this.id == thread.id;
    },
    getName: function () {
        return this.buffer.getName();
    },
    threadId: function () {
        return this.buffer.threadId(this.id);
    },
    urlParts: function () {
        return [this.buffer.idNamespace(), this.buffer.idName(), 'thread', this.threadId()];
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl() + 'messages/' + this.normalise() + '/convo/' + this.id;
    },
    getTitle: function () {
        return 'Thread from ' + this.buffer.getTitle();
    },
    getTarget: function () {
        return this.buffer.getName();
    },
    isThread: function () {
        return true;
    },
    isSelf: function () {
        return this.buffer.isSelf();
    }
});


module.exports = Thread;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/thread.js
// module id = ptDp
// module chunks = 1